module.exports = __webpack_public_path__ + "img/main.b2ef3f9d.png";